export class AddingRigCancellationError extends Error {}
